<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="relative z-50" @close="() => {}">
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-900/70 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel class="relative w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white px-10 pt-10 pb-10 text-center shadow-2xl transition-all sm:my-8">
                            <DialogTitle as="h3" class="text-3xl font-bold text-gray-900 tracking-tight">
                                Get Unlimited Report Views With
                            </DialogTitle>

                            <h4 class="mt-8 text-lg font-bold italic text-gray-900">RiskGuard Pro Subscription</h4>

                            <ul class="mt-4 space-y-1 text-sm text-gray-800">
                                <li>Digitally Sign Docs</li>
                                <li>Anti-fraud Verification</li>
                                <li>Expedited ACH Payments</li>
                                <li>Access All Real Estate Docs</li>
                                <li>Unlimited Application Views</li>
                                <li>State-Specific Lease Agreements</li>
                            </ul>

                            <p class="mt-6 text-sm font-semibold text-gray-900">${{ $page.props.subscription_prices.riskguard_pro_monthly }}/mo. Cancel Anytime</p>

                            <button
                                type="button"
                                @click="$emit('upgrade')"
                                :disabled="processing"
                                class="mt-6 inline-block rounded-md bg-rent-risk-blue-400 px-10 py-4 text-base font-bold uppercase tracking-wide text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rent-risk-blue-400 disabled:opacity-60 disabled:cursor-not-allowed"
                            >
                                {{ processing ? 'Processing...' : 'Yes, Upgrade to Pro' }}
                            </button>

                            <button
                                type="button"
                                @click="$emit('decline')"
                                class="block mx-auto mt-5 text-sm text-gray-600 hover:text-gray-900 underline"
                            >
                                I don't need to view this application
                            </button>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    processing: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['upgrade', 'decline'])
</script>
